<template>
  <div class="add-us">
    <div class="add-us__top">
      <img class="add-us__top__img" src="../assets/image/addUs_1.png" alt="">
      <div class="add-us__top__text1">
        <p>和优秀的人，做有挑战的事</p>
      </div>
      <div class="add-us__top__text2">
        <p>WITH GREAT PEOPLE, DO CHALLENGING THINGS</p>
      </div>
    </div>
    <div class="add-us__middle">
      <div class="add-us__middle__title">
        <p>联系我们</p>
        <p>CONTACT US</p>
      </div>
      <div class="add-us__middle__text">
        <div class="add-us__middle__text__container">
          <img src="../assets/image/addUs_2.png" alt="">
          <div class="info">
            <div>
              <p>客服电话</p>
              <p>400-123-4567</p>
            </div>
            <div>
              <p>公司邮箱</p>
              <p>yuelian@Linda.com</p>
            </div>
            <div>
              <p>总部地址</p>
              <p>上海市青浦区华徐公路685号6栋</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddUs',
  data () {
      return {
        center: {
          lng: 0,
          lat: 0
        },
        zoom: 3
      }
  }
}
</script> 

<style lang="scss" scoped>
.add-us{
  &__top{
    position: relative;
    width: 100%;
    &__img{
      width: 100%;
      min-width: 1440px;
      max-width: 1920px;
    }
    &__text1{
      width: 100%;
      position: absolute;
      text-align: center;
      color: #fff;
      font-size: 40px;
      top: 300px;
      line-height: 50px;
    }
    &__text2{
      width: 100%;
      position: absolute;
      text-align: center;
      color: #F8F8F8;
      font-size: 15px;
      top: 360px;
      line-height: 24px;
      letter-spacing:3px;
    }
  }
  &__middle{
    margin: 140px auto;
    &__title{
      font-size: 40px;
      color: #333;
      width: 880px;
      text-align: center;
      margin: 0 auto;
      height: 60px;
      position: relative;
      p:first-child{
          font-size: 40px;
          margin-bottom: -15px;
          font-family: webfont__bold;
      }
      p:last-child{
        font-size: 34px;
        opacity: 0.07;
      }
    }
    &__text{
      width: 1400px;
      margin: 72px auto;
      font-size: 14px;
      text-align: left;
      color: #666;
      background-color: #fff;
      border-radius: 20px;
      line-height: 30px;
      &__container{
        padding: 77px 30px;
        display: flex;
        justify-content: flex-start;
        img{
          width: 600px;
        }
        .info{
          flex: 1;;
          margin: -30px 0px 0px 48px;
          div{
            height: 100px;
            border-bottom: 1px solid #eee;
            p:first-child{
              color: #666;
              font-size: 14px;
              margin-top: 25px;
            }
            p:last-child{
              color: #333;
              font-size: 20px;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/addUs.vue